import React, { memo } from 'react'
import Styled from 'styled-components'
import FilterGroup from './filter_group'
import FilterSelected from './filter_selected'

const FilterFinder = () => {
    return (
        <Wrap>
            <FilterGroup />
            <FilterSelected />
        </Wrap>
    )
}

const Wrap = Styled.div`
    margin: 0 0 50px;
    border: 1px solid #c8c8c8;
    border-left: 0;
`

export default memo(FilterFinder)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/index.js